/**
 * Main application entry point.
 *
 * @author Stanislav Kalashnik <sk@infomir.eu>
 * @license GNU GENERAL PUBLIC LICENSE Version 3
 */

'use strict';

var app = require('mag-app');

app.gettext = require('spa-gettext');

// main application events
app.once('load', function () {
    // load language first
    app.gettext.load({name: window.core.environment.language}, function ( error ) {
        if ( error ) { debug.info('language load error'); }
        // set pages
        app.pages = {
            main: require('./pages/main'),
            info: require('./pages/info'),
            logs: require('./pages/logs'),
            usb: require('./pages/usb'),
            url: require('./pages/url')
        };

        app.ready();
    });
});
